// extracted by mini-css-extract-plugin
module.exports = {"notfound_container":"NotFoundLottie_notfound_container__g6mbi","content":"NotFoundLottie_content__1aKJ7"};